<div class="row m-0 p-0">
    <div class="col-12 col-md-7">
        <app-form-field label="Street">
            <input [(ngModel)]="address.street" type="text" class="form-control" required [readonly]="readOnly">
        </app-form-field>
    </div>
    <div class="col-8 col-md-3">
        <app-form-field label="House number">
            <input [(ngModel)]="address.number" type="text" class="form-control" required [readonly]="readOnly">
        </app-form-field>
    </div>
    <div class="col-4 col-md-2">
        <app-form-field label="Addition">
            <input [(ngModel)]="address.addition" type="text" class="form-control" [readonly]="readOnly">
        </app-form-field>
    </div>
    <div class="col-12 col-md-6">
        <app-form-field label="Zipcode">
            <input [(ngModel)]="address.zipCode" type="text" class="form-control" required [readonly]="readOnly"
                   (ngModelChange)="address.zipCode = upperCase(address.zipCode)">
        </app-form-field>
    </div>
    <div class="col-12 col-md-6">
        <app-form-field label="City">
            <input [(ngModel)]="address.city" type="text" class="form-control" required [readonly]="readOnly">
        </app-form-field>
    </div>
    <div class="col-12 col-md-6">
        <app-form-field label="Country">
            <input [(ngModel)]="address.country" type="text" class="form-control" required [readonly]="readOnly"
                   (ngModelChange)="address.country = upperCase(address.country)">
        </app-form-field>
    </div>
</div>
<div *ngIf="collapseGeoLocation && !showGeoLocation" class="geo-location-summary mx-0 mt-3">
    <div>
        <i class="bi bi-geo-alt-fill"></i>
        <span>Coordinates automatically filled</span>
    </div>
    <div class="geo-location-summary-actions">
        <button type="button" class="btn btn-sm btn-link" (click)="showGeoLocationFields(false)">View</button>
        <button type="button" class="btn btn-sm btn-link" (click)="showGeoLocationFields(true)">Edit manually</button>
    </div>
</div>
<div *ngIf="!collapseGeoLocation || showGeoLocation" class="row m-0 p-0">
    <h6 class="col-12 header-pretitle mt-3">Geo location</h6>
    <div class="col-12 col-md-6">
        <app-form-field label="Latitude">
            <input required [(ngModel)]="address.geoLocation.latitude" type="number" step="any" min="-90" max="90"
                   class="form-control" [readonly]="readOnly && !editGeoLocation">
        </app-form-field>
    </div>
    <div class="col-12 col-md-6">
        <app-form-field label="Longitude">
            <input required [(ngModel)]="address.geoLocation.longitude" type="number" step="any" min="-180" max="180"
                   class="form-control" [readonly]="readOnly && !editGeoLocation">
        </app-form-field>
    </div>
</div>
